@if (distribution) {
  <div class="detail-container">

    <div class="detail-header">
      <div class="header-info">
        <div class="header-item">
          <span class="header-label">Distribution Period</span>
          <span class="header-value period-value">
            {{ formatPeriod(distribution.periodStart, distribution.periodEnd) }}
          </span>
        </div>
        <div class="header-divider"></div>
        <div class="header-item">
          <span class="header-label">Gross Collected</span>
          <span class="header-value amount-value">
            {{ distribution.grossCollected | currency:'USD':'symbol':'1.2-2' }}
          </span>
        </div>
        <div class="header-divider"></div>
        <div class="header-item">
          <span class="header-label">Status</span>
          <span class="status-badge" [ngClass]="'status-' + distribution.status.toLowerCase().replace('_', '-')">
            {{ getStatusLabel(distribution.status) }}
          </span>
        </div>
      </div>
    </div>

    <div class="mat-elevation-z2 table-container">
      <table mat-table [dataSource]="distribution.subReports" aria-label="Sub-reports">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Report name</th>
          <td mat-cell *matCellDef="let row">
            <div class="report-name-cell">
              <mat-icon class="report-icon">description</mat-icon>
              <span>{{ row.name }}</span>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="clickable-row"
          (click)="onViewReport(row)">
        </tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
            No reports available for this distribution.
          </td>
        </tr>
      </table>
    </div>

    <div class="footer-actions">
      <button mat-stroked-button [routerLink]="['/app/distributions']" class="back-btn">
        <mat-icon>arrow_back</mat-icon>
        GO BACK
      </button>
    </div>

  </div>
} @else {
  <div class="loading-state">
    <mat-icon>hourglass_empty</mat-icon>
    <span>Loading distribution details...</span>
  </div>
}
